import React from "react";
import { Card } from "react-bootstrap";

const OutwardLetter = ({ data }) => {
    const currentDate = new Date().toLocaleDateString("en-GB");

    const formatDMY = (d) => {
        if (!d) return "-";
        const [day, month, year] = d.split("/");
        return `${day}/${month}/${year}`;
    };

    const formatISODate = (d) => {
        return new Date(d).toLocaleDateString("en-GB", { timeZone: "UTC" });
    };
    return (
        <Card
            className="p-5 border-0"
            style={{
                fontSize: "16px",
                lineHeight: "1.6",
                backgroundColor: "#fff",
                fontFamily: '"Times New Roman", Times, serif'
            }}
        >
            {/* Title */}
            <h5
                className="text-center mb-3 custom-heading"
                style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    textDecoration: "underline"
                }}
            >
                TRANSFER LETTER AND UNDERTAKING FOR E-SCRIP
            </h5>

            {/* To Section - Client/Recipient */}
            <div className="mb-3">
                <p className="mb-2">
                    <strong>To,</strong>
                </p>
                <p className="mb-1" style={{ fontWeight: "500" }}>
                    {data.client_name || "-"}
                </p>
                <p className="mb-2" style={{ whiteSpace: "pre-line" }}>
                    {data.address || "-"}
                </p>
                <p className="mb-1">
                    <strong>GSTN:</strong> {data.gstin || "-"}
                </p>
                <p className="mb-3">
                    <strong>ICEGATE ID:</strong> {data.icegate_id || "-"}
                </p>

                {/* Subject */}
                <p
                    className="mb-3"
                    style={{
                        textDecoration: "underline",
                        fontWeight: "500"
                    }}
                >
                    Subject: Sale and Transfer of RoSCTL/RoDTEP Duty Credit E-scrip in your favour as per Foreign Trade Policy in force and Notifications No. 75/2021 Customs (NT) dtd. 23.09.2021 and/or Notification No. 76/2021 Customs (NT) dtd. 23.09.2021 and/or Notification No. 77/2021 Customs (NT) dtd. 24.09.2021.
                </p>

                {/* E-scrip Details */}
                <p className="mb-1">
                    <strong>E-scrip No. :</strong> {data.escrip_no || "-"} &nbsp;&nbsp;
                    <strong>Dated :</strong>{data.dated ? formatISODate(data.dated) : "-"}
                    &nbsp;&nbsp;
                    <strong>Duty Credit Amt (Rs.):</strong> {data.amount || "-"}
                </p>
                <p className="mb-3">
                    <strong>Port Code :</strong> {data.port_code || "-"} &nbsp;&nbsp;
                    <strong>IEC :</strong> {data.iec || "-"}
                </p>
            </div>

            {/* Letter Body */}
            <div style={{ fontSize: "16px" }}>
                <p className="mb-3">Dear Sir/Madam,</p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We are enclosing herewith certified statement of shipping bills and bank realisation certificates (BRCs) against our said E-scrip on all applicable cases. We do hereby transfer the E-scrip in your favour as per current Foreign Trade Policy in force and applicable notifications as stated above. We also confirm that you will not require any separate authority from us, and we shall have no right or claim of whatsoever on the said E-scrip henceforth.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We also confirm that the export proceeds/payments against all the shipping bills/export invoices covered under this E-scrip are realised or would be realised in due course as per RBI guidelines. We undertake that in case of any demand being raised by any authority for short or non-realization of the proceeds we would be fully liable for the same. We indemnify the transferee and the actual user-importer against any such liabilities and actions under the above stated notifications.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We are fully responsible for the genuineness and bona fide of the said E-scrip. We hereby confirm to pay the amount to the transferee and the actual user-importer if demanded by any government authority due to any deficiency/fault of whatsoever nature raised against the said E-scrip.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    We are transferring the E-scrip on ICEGATE portal in your E Ledger <strong>{data.icegate_id || "-"}</strong> to complete the transfer to you. It is hereby agreed that the actual user-importer will operate on the said E-scrip and the goods thus imported will be strictly in accordance with the foreign trade policy in force for their sole benefit and for any infringement/violation of rule and regulation committed by them, they shall be fully responsible for the same and they shall keep us indemnified at all times.
                </p>

                <p className="mb-3" style={{ textAlign: "justify" }}>
                    The final responsibility for the accuracy, completeness, and timely submission of the BRC shall rest solely with the exporter. Preface Ventures shall not, under any circumstances, be held liable or accountable for any errors, omissions, delays, or non-compliance related to the preparation, verification, or submission of the BRC.
                </p>
            </div>

            {/* Signature Section */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "40px",
                    alignItems: "flex-start"
                }}
            >
                {/* Left Side - Your Company Signature */}
                <div>
                    <p className="mb-1">Yours faithfully</p>
                    <p className="mb-0">For</p>
                    <div style={{ height: "60px" }}></div>
                    <p className="mb-1" style={{ fontWeight: "600" }}>
                        {/* {data.preface_details.name} */}
                        Preface Venture Pvt Ltd
                    </p>
                    <p className="mb-1">Authorized Signatory.</p>
                    <p className="mb-0">Date: {formatDMY(data.date)}</p>
                </div>

                {/* Right Side - Bank Attestation Box */}
                <div
                    style={{
                        width: "200px",
                        minHeight: "100px",
                        border: "2px solid #000",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        padding: "5px",
                        fontWeight: "500",
                        fontSize: "14px",
                    }}
                >
                    Signature Attestation by Bank
                </div>
            </div>
        </Card>
    );
};

export default OutwardLetter;